import { action, props } from 'ts-action';
import { Abnormality, Definition, Diagnostic } from '../types/diagnostic';
import { SkipHistory } from '../../undo/actions/undo.actions';

export const setDiagnostics = action(
  '[Diagnostics] setDiagnostics',
  props<
    {
      baseDiagnostic: Diagnostic;
      diagnostics: Diagnostic[];
      editableDiagnostic: Diagnostic;
    } & SkipHistory
  >(),
);

export const setDefinitions = action(
  '[Diagnostics] setDefinitions',
  props<
    {
      definitions: Definition[];
      primaryDefinitions: Definition[];
    } & SkipHistory
  >(),
);

export const setAbnormalities = action(
  '[Diagnostics] setAbnormalities',
  props<{ abnormalities: Abnormality[] }>(),
);

export const setComment = action(
  '[Diagnostics] setComment',
  props<{ comment: string }>(),
);

export const setDiagnosticIndex = action(
  '[Diagnostics] setDiagnosticIndex',
  props<{ diagnosticIndex: number }>(),
);

export const save = action(
  '[Diagnostics] save',
  props<{ diagnostic: Diagnostic } & SkipHistory>(),
);
